<template>
  <checkout v-if="user" v-bind:trans="trans_checkout" v-bind:lang="lang" v-bind:redirect="redirect" v-bind:free="free">
  </checkout>
  <login-component v-else v-bind:trans="trans_auth" v-bind:lang="lang" redirect="checkout"
    v-bind:showLoader="showLoader"></login-component>
</template>

<script>
import CheckoutComponent from './CheckoutComponent.vue';
import LoginComponent from './LoginComponent.vue';

export default {
  props: ['lang', 'trans_checkout', 'trans_auth', 'redirect', 'free'],
  name: "CheckoutLoginComponent",
  components: { CheckoutComponent, LoginComponent },
  data() {
    return {
      user: null,
      showLoader: true
    }
  },
  mounted() {
    this.$store.dispatch('user', {
      path: this.$path
    }).then((response) => {
      this.user = response.data;

      if (!this.user) {
        this.showLoader = false;
      }
    }).catch(() => {
      this.showLoader = false;
    });
  }
}
</script>
